import React from "react";
import module_style from "./style.module.css";
import style from "../../style.module.css";
import { Input, Button } from "@my-scoot/component-library-legacy";
import InfoOutlined from "@material-ui/icons/InfoOutlined";
import AddCircle from "@material-ui/icons/AddCircle";
import ExlyModal from "common/Components/ExlyModal";
import { is_empty, validURLV2 } from "utils/validations";
import { api, dataProvider } from "data";
import constants from "constants/constants";
import { useNotifications } from "utils/hooks";
import { ImageUploader } from "ui/pages/TemplatePreview/widgets";
import BrandsList from "./Components/BrandsList";
import { refreshIframe, validateData, findSelectedData } from "./Utils";
import placeholderImg from "assets/images/image-uploader-placeholder.png";
import { WebpageCreationContext } from "ui/pages/TemplatePreview";
import {
  BrandCollabrationLabels,
  MiscellaneousConfig,
  TEMPLATE_KEYS,
  SIDEBAR_KEYS,
  SECTIONKEY_TO_MISC_KEY,
} from "ui/pages/TemplatePreview/constants";
import useTemplatePreview from "ui/pages/TemplatePreview/hooks/useTemplatePreview";
import classnames from "classnames";
import { creator_miscellaneous_data_types } from "features/Common/modules/CreatorData/CreatorData.constants";
import { IMAGE_SECTION_KEY_PATH } from "features/Common/modules/ExlyImage/constants/ExlyImage.constants";
import SectionVisibilityToggle from "../hideShow";
import { handleVisibilityToggle } from "../../utils";
import useVisibilityMutations from "../../useVisibilityMutations.hook";

const firstItemIndex = 0;

const BrandCollaborations = (props) => {
  const {
    disableAllEdits,
    state: {
      template: { slug },
    },
  } = props;

  const { notify } = useNotifications();
  const {
    miscellaneous_data,
    fetchMiscellaneousData,
    set_miscellaneous_data,
    setMiscellaneousUpdate,
  } = React.useContext(WebpageCreationContext);
  const { pushNotif } = useTemplatePreview();
  const templateLabels =
    slug in BrandCollabrationLabels
      ? BrandCollabrationLabels[slug]
      : BrandCollabrationLabels.default;
  const [sectionName, set_sectionName] = React.useState(templateLabels.label);
  const [show_modal, set_show_modal] = React.useState(false);
  const [uuid, set_uuid] = React.useState(null);
  const [processing, set_processing] = React.useState(false);
  const [selected_id, set_selected_id] = React.useState(null);
  const [data, set_data] = React.useState([]);
  const [error_object, set_error_object] = React.useState({});
  const [visible, set_visible] = React.useState(true);
  const draftDataRef = React.useRef(null);

  // Mutations for visibility toggle
  const { createMutation, updateMutation } = useVisibilityMutations();

  React.useEffect(() => {
    assignData();
  }, [miscellaneous_data]);

  const assignData = async () => {
    try {
      if (is_empty(miscellaneous_data?.brands)) return;
      let temp = miscellaneous_data?.brands[firstItemIndex];
      set_data(Array.isArray(temp?.data?.data) ? temp.data.data : []);
      const backendSectionName = temp?.data?.section_name;

      set_sectionName(
        backendSectionName && backendSectionName.trim()
          ? backendSectionName
          : templateLabels.label
      );

      set_uuid(temp?.uuid);

      // SAFETY NET: default visible = true
      set_visible(temp?.data?.visible ?? true);
    } catch (err) {
      console.error("assign brands err", err);
      notify(
        err?.body?.message ? err?.body?.message : constants.error_message,
        "error"
      );
    }
  };

  const handleSave = async ({
    currentData,
    selectedId,
    currentUuid,
    currentVisible,
    currentSectionName,
  }) => {
    try {
      if (processing) return;
      set_processing(true);

      const draft = draftDataRef?.current;

      const hasDraftData =
        draft?.brand_name || draft?.brand_logo || draft?.brand_url;

      const hasActualData =
        Array.isArray(currentData) &&
        currentData.some(
          (item) =>
            !item.draft &&
            (item.brand_name || item.brand_logo || item.brand_url)
        );

      if (!hasActualData && !hasDraftData) {
        set_show_modal(false);
        set_selected_id(null);
        return;
      }

      const selected_data = Number.isInteger(selectedId)
        ? findSelectedData(currentData, selectedId) || draftDataRef.current
        : null;

      let error_obj = {};

      if (selected_data) {
        const validateErrorObj = validateData(
          { brand_logo: selected_data.brand_logo },
          "Required"
        );
        error_obj = { ...validateErrorObj };

        if (selected_data.brand_url && !validURLV2(selected_data.brand_url)) {
          error_obj.brand_url = true;
        }

        if (!is_empty(error_obj)) {
          set_error_object(error_obj);
          notify("Invalid form values", "error");
          return;
        }
      }

      let temp = [...currentData];

      if (temp[selectedId]?.draft) {
        delete temp[selectedId].draft;
      }

      let payload, api_resource;

      if (is_empty(currentUuid)) {
        api_resource = api.creator_miscellaneous_data.create;
        payload = {
          type: creator_miscellaneous_data_types.BRAND_COLLABORATION,
          data: {
            section_name: currentSectionName,
            visible: currentVisible,
            data: temp,
          },
        };
      } else {
        api_resource = api.creator_miscellaneous_data.update;
        payload = {
          uuid: currentUuid,
          updated_values: {
            data: {
              section_name: currentSectionName,
              visible: currentVisible,
              data: temp,
            },
          },
        };
      }

      const status = await dataProvider.custom_request(
        api_resource,
        "POST",
        payload
      );

      if (status.status === 200) {
        refreshIframe();
        set_data(temp);
        set_show_modal(false);
        set_selected_id(null);
        set_error_object({});
      }

      pushNotif(status?.message);
    } catch (err) {
      notify(
        err?.body?.message ? err?.body?.message : constants.error_message,
        "error"
      );
    } finally {
      set_processing(false);
    }
  };

  const handleDelete = () => {
    if (selected_id === null) return;

    const temp = [...data];

    temp.splice(Number(selected_id), 1);

    const updatedData = temp.map((item, index) => ({
      ...item,
      id: index,
    }));

    set_data(updatedData);

    handleSave({
      currentData: updatedData,
      selectedId: null,
      currentUuid: uuid,
      currentVisible: visible,
      currentSectionName: sectionName,
    });
  };

  const updateData = (value, key) => {
    let temp = data;
    temp[selected_id][key] = value;
    set_data([...temp]);
  };

  const handleModalClose = () => {
    set_show_modal(false);
    set_error_object({});
    set_selected_id(null);
    // remove draft entries
    let published_data = data.filter((item) => !item.draft);
    set_data([...published_data]);
  };

  React.useEffect(() => {
    setMiscellaneousUpdate((prev) => ({
      ...prev,
      brandCollaborationSection: {
        handleSave: () =>
          handleSave({
            currentData: data,
            selectedId: selected_id,
            currentUuid: uuid,
            currentVisible: visible,
            currentSectionName: sectionName,
          }),
      },
    }));
  }, [sectionName, data]);

  const onToggleVisibility = () =>
    handleVisibilityToggle({
      currentVisible: visible,
      setVisible: set_visible,
      miscellaneousData: miscellaneous_data,
      sectionKey: SECTIONKEY_TO_MISC_KEY[SIDEBAR_KEYS.BRAND_COLLABORATIONS],
      sectionType: creator_miscellaneous_data_types.BRAND_COLLABORATION,
      currentSectionName: sectionName,
      fetchMiscellaneousData,
      set_miscellaneous_data,
      createMutation: createMutation,
      updateMutation: updateMutation,
      currentData: data,
    });

  return (
    <div>
      <SectionVisibilityToggle
        visible={visible}
        disabled={disableAllEdits}
        onToggle={onToggleVisibility}
      />

      <div className={style.label}>
        What would you like to call this section?
      </div>
      <div className={`mt-2`}>
        <Input
          fullWidth
          value={sectionName}
          error={error_object.sectionNameLength}
          helperText={error_object?.sectionNameLength}
          inputProps={{
            maxLength: MiscellaneousConfig.maxTitleLength,
          }}
          onChange={(e) => {
            let value = e.target.value;
            if (value.length >= MiscellaneousConfig.maxTitleLength) {
              set_error_object({
                ...error_object,
                sectionNameLength: `Maximum field length of ${MiscellaneousConfig.maxTitleLength} reached.`,
              });
            } else {
              set_error_object({ ...error_object, sectionNameLength: false });
            }
            set_sectionName(value);
          }}
          disabled={disableAllEdits}
        />
      </div>
      <div className={`${style.info} tw-my-[16px]`}>
        <InfoOutlined className={`${style.infoIcon}`} />
        The items can be dragged up and down using the &#10303; icon to change
        the order in which they appear.
      </div>
      {!is_empty(data) && (
        <BrandsList
          data={data}
          set_data={(value) => set_data(value)}
          set_show_modal={(value) => set_show_modal(value)}
          uuid={uuid}
          handleDelete={() => handleDelete()}
          selected_id={selected_id}
          set_selected_id={(value) => set_selected_id(value)}
          disableAllEdits={disableAllEdits}
        />
      )}
      <div className={`d-flex mt-4 align-items-center justify-content-between`}>
        {disableAllEdits ? (
          <div />
        ) : (
          <div
            onClick={() => {
              if (processing) return;
              let initial_data = {
                id: (data || []).length,
                brand_name: "",
                brand_logo: "",
                brand_url: "",
                draft: true,
              };
              set_selected_id(data.length);
              set_data([...data, initial_data]);
              draftDataRef.current = initial_data;
              set_show_modal(true);
            }}
            className={`${module_style.action_color} ${module_style.text_cta} pointer`}
          >
            <AddCircle />
            <span className={`ml-2`}>Add brand collaboration</span>
          </div>
        )}
        <Button
          variant="contained"
          color="primary"
          disableElevation
          disabled={processing || disableAllEdits}
          loading={processing}
          onClick={() =>
            handleSave({
              currentData: data,
              selectedId: selected_id,
              currentUuid: uuid,
              currentVisible: visible,
              currentSectionName: sectionName,
            })
          }
        >
          Save
        </Button>
      </div>
      <ExlyModal
        title={templateLabels.modal.modalTitle}
        open={show_modal}
        onClose={handleModalClose}
        primaryBtnText={processing ? "..." : "Save"}
        onPrimaryBtnClick={() =>
          handleSave({
            currentData: data,
            selectedId: selected_id,
            currentUuid: uuid,
            currentVisible: visible,
            currentSectionName: sectionName,
          })
        }
        modal_props={{
          modalPaperClassName: module_style.miscellaneous_data_modal,
        }}
      >
        {Number.isInteger(selected_id) && data[selected_id] && (
          <div className={`pt-4 pb-4`}>
            <div className={`${style.label} ${style.required}`}>
              {templateLabels.modal.logoTitle}
            </div>
            <div className={`d-flex mt-2`}>
              <div>
                <ImageUploader
                  hideRecommendedText
                  uploadUrl={data[selected_id]?.brand_logo}
                  setUploadUrl={(firebaseUrl) => {
                    if (error_object?.brand_logo) {
                      set_error_object({ ...error_object, brand_logo: false });
                    }
                    updateData(firebaseUrl, "brand_logo");
                  }}
                  fullWidth={50}
                  hoverText="Upload Image"
                  width={84}
                  height={84}
                  customDefaultImage={placeholderImg}
                  borderRadius="4px"
                  query={"brand"}
                  id="website_brand_logo"
                  uploadViaOptimization
                  sectionName={IMAGE_SECTION_KEY_PATH.HOME_PAGE}
                />
                {error_object?.brand_logo && (
                  <div className={`text-danger small`}>Invalid</div>
                )}
              </div>
              <div
                className={classnames("tw-ml-4", style.info, style.alignCenter)}
              >
                Recommended format:
                <br />
                150 x 150 pixels (PNG or JPG)
              </div>
            </div>
            <div className={`${style.label} mt-3 mb-1`}>
              {templateLabels.modal.logoTextLabel}
            </div>
            <Input
              error={error_object?.brand_name}
              helperText={error_object?.brand_name}
              fullWidth
              value={data[selected_id]?.brand_name}
              inputProps={{
                maxLength: MiscellaneousConfig.maxTitleLength,
              }}
              onChange={(e) => {
                let value = e.target.value;
                set_error_object({ ...error_object, brand_name: false });
                updateData(value, "brand_name");
              }}
            />
            {/**
             * The below condition is for a limited time.
             * TODO: Make it template wide.
             * But until then, we are here.
             */}
            {slug === TEMPLATE_KEYS.UNLOCK && (
              <>
                <div className={classnames(style.label, "mt-3", "mb-1")}>
                  Brand URL
                </div>
                <Input
                  error={error_object?.brand_url}
                  helperText={error_object?.brand_url ? "Invalid URL" : null}
                  placeholder="Enter URL here"
                  value={data[selected_id]?.brand_url}
                  fullWidth
                  onChange={(e) => {
                    let value = e.target.value;

                    if (value && !validURLV2(value)) {
                      set_error_object({ ...error_object, brand_url: true });
                    } else {
                      set_error_object({ ...error_object, brand_url: false });
                    }
                    updateData(value, "brand_url");
                  }}
                />
              </>
            )}
          </div>
        )}
      </ExlyModal>
    </div>
  );
};
export default BrandCollaborations;
